import React, { ChangeEvent, FunctionComponent, SyntheticEvent } from "react";
import "./styles.scss";
import { Icon } from "../../../Icon";

type Props = {
  handleClose: () => void;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleSearch: (e: SyntheticEvent) => void;
};
const SearchModal: FunctionComponent<Props> = ({
  handleClose,
  handleChange,
  handleSearch,
}) => {
  return (
    <section className="search-modal">
      <div onClick={handleClose} className="search-modal__close">
        <Icon iconName="close_icon" className="search-modal__close--icon" />
      </div>
      <div className="search-modal__contain">
        <form
          className="nav_search_bar search-modal__contain--form"
          onSubmit={handleSearch}
        >
          <button>
            <Icon iconName="search_icon" />
          </button>
          <input
            type="text"
            placeholder="Buscar..."
            name="product"
            id="product"
            onChange={handleChange}
            className="search-modal__contain--input"
          />
        </form>
      </div>
    </section>
  );
};

export default SearchModal;
